<template>
  <div
    class="c-home-care-img"
    :class="{ 'c-home-care-img--margin-top': mt, 'c-home-care-img--margin-bottom': mb, 'c-home-care-img--inline': inline, 'c-home-care-img--center': center }"
    :style="{ textAlign: textAlign }"
  >

      <div class="c-home-care-img__img" :class="[`c-home-care-img__img--${type}`]"></div>
      <p class="c-home-care-label">{{ label }}</p>

  </div>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HomeCareImg',
  props: {
    type: {
      default: null,
    },
    maxWidth: {
      type: String,
      default: '100%',
    },
    mt: {
      type: Boolean,
      default: true,
    },
    mb: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: '',
    },
    inline: {
      type: Boolean,
      default: false,
    },
    center: {
      type: Boolean,
      default: false,
    },
  },
});
</script>
<style lang="scss" scoped>
.c-home-care-img {
  margin: 0px;

  &--margin-top {
    margin-top: 50px;
  }

  &--margin-bottom {
    margin-bottom: 10px;
  }

  &--center {
    @include flex(center, center, column);
  }

  &--inline {
    @include flex();
  }

  &__img {
    width: 100px;
    height: 100px;
    background-size: 100px 100px;
    background-position: center;
    background-repeat: no-repeat;

    &--heart {
      background-image: url('~@/assets/homeCare/heart.svg');
    }

    &--typical-symptoms {
      background-image: url('~@/assets/homeCare/typical-symptoms.svg');
    }

    &--atypical-symptoms {
      background-image: url('~@/assets/homeCare/atypical-symptoms.svg');
    }
    &--degree-impact {
      background-image: url('~@/assets/homeCare/degree-impact.svg');
    }
    &--ultrasound-examination {
      background-image: url('~@/assets/homeCare/ultrasound-examination.svg');
    }
    &--treat {
      background-image: url('~@/assets/homeCare/treat.svg');
    }
    &--words-for-mom-and-dad {
      background-image: url('~@/assets/homeCare/words-for-mom-and-dad.svg');
    }
    &--supplementary-knowledge {
      background-image: url('~@/assets/homeCare/supplementary-knowledge.svg');
    }
    &--diagnosis {
      background-image: url('~@/assets/homeCare/diagnosis.svg');
    }

    &--retina-introduction {
      background-image: url('~@/assets/homeCare/retina-introduction.svg');
    }
    &--retina-definition {
      background-image: url('~@/assets/homeCare/retina-definition.svg');
    }
    &--retina-examination {
      background-image: url('~@/assets/homeCare/retina-examination.svg');
    }
    &--retina-fundus-examination {
      background-image: url('~@/assets/homeCare/retina-fundus-examination.svg');
    }
    &--retina-diagnosis {
      background-image: url('~@/assets/homeCare/retina-diagnosis.svg');
    }

    &--jaundice-breastfeeding {
      background-image: url('~@/assets/homeCare/jaundice-breastfeeding.svg');
    }
    &--jaundice-physiological {
      background-image: url('~@/assets/homeCare/jaundice-physiological.svg');
    }

    &--physiological-dehydration {
      background-image: url('~@/assets/homeCare/physiological-dehydration.svg');
    }

    &--hearing-screening {
      background-image: url('~@/assets/homeCare/hearing-screening.svg');
    }
    &--hearing-loss {
      background-image: url('~@/assets/homeCare/hearing-loss.svg');
    }

    &--vaccination-importance {
      background-image: url('~@/assets/homeCare/vaccination-importance.svg');
    }
    &--vaccination-principles {
      background-image: url('~@/assets/homeCare/vaccination-principles.svg');
    }
    &--vaccination-pre-vaccination-assessment {
      background-image: url('~@/assets/homeCare/vaccination-pre-vaccination-assessment.svg');
    }

    &--newborn-care-behavioural-messages {
      background-image: url('~@/assets/homeCare/newborn-care-behavioural-messages.svg');
    }
    &--newborn-care-take-fcocused-care {
      background-image: url('~@/assets/homeCare/newborn-care-take-fcocused-care.svg');
    }
    &--newborn-care-posture-support {
      background-image: url('~@/assets/homeCare/newborn-care-posture-support.svg');
    }

    &--senses-vision {
      background-image: url('~@/assets/homeCare/senses-vision.svg');
    }
    &--senses-hearing {
      background-image: url('~@/assets/homeCare/senses-hearing.svg');
    }
    &--senses-smell {
      background-image: url('~@/assets/homeCare/senses-smell.svg');
    }
    &--senses-taste {
      background-image: url('~@/assets/homeCare/senses-taste.svg');
    }
    &--senses-execution {
      background-image: url('~@/assets/homeCare/senses-execution.svg');
    }

    &--kangaroo-care-benefits {
      background-image: url('~@/assets/homeCare/kangaroo-care-benefits.svg');
    }
    &--kangaroo-care-execution {
      background-image: url('~@/assets/homeCare/kangaroo-care-execution.svg');
    }
    &--kangaroo-care-preparing {
      background-image: url('~@/assets/homeCare/kangaroo-care-preparing.svg');
    }

    &--parent-child-reading-habits {
      background-image: url('~@/assets/homeCare/parent-child-reading-habits.svg');
    }
    &--parent-child-reading-reading-tool {
      background-image: url('~@/assets/homeCare/parent-child-reading-reading-tool.svg');
    }
    &--parent-child-reading-environment {
      background-image: url('~@/assets/homeCare/parent-child-reading-environment.svg');
    }
    &--parent-child-reading-remarks {
      background-image: url('~@/assets/homeCare/parent-child-reading-remarks.svg');
    }

    &--premature-massage-prep {
      background-image: url('~@/assets/homeCare/premature-massage-prep.svg');
    }
    &--premature-massage-time {
      background-image: url('~@/assets/homeCare/premature-massage-time.svg');
    }
    &--premature-massage-sequence {
      background-image: url('~@/assets/homeCare/premature-massage-sequence.svg');
    }

    &--checking {
      background-image: url('~@/assets/homeCare/checking.svg');
    }

    &--checking {
      background-image: url('~@/assets/homeCare/checking.svg');
    }

    &--memo {
      background-image: url('~@/assets/homeCare/memo.svg');
    }

    &--share-reading {
      background-image: url('~@/assets/homeCare/share-reading.svg');
    }
    &--affect {
      background-image: url('~@/assets/homeCare/affect.svg');
    }
    &--surgery {
      background-image: url('~@/assets/homeCare/surgery.svg');
    }
    &--level-group {
      background-image: url('~@/assets/homeCare/level-group.svg');
    }
    &--eye-function {
      background-image: url('~@/assets/homeCare/eye-function.svg');
    }
  }
}

.c-home-care-label {
  margin-top: 10px;
  @include font-normal();
}
</style>
